import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { resetPaymentState } from '@store/modules/payment';

@Injectable({
  providedIn: 'root'
})
export class PaymentFacadeService {
     readonly #store = inject(Store);

     reset() {
      this.#store.dispatch(resetPaymentState());
     }
}
